import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { ApiLinkContext } from '../context/ApiLinkContext'
import bioimg from "../assets/image/bio.png"
import translations from "../data/langData";
import { LanguageContext } from "../context/LanguageContext";
const Biography = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const {bio} = useContext(ApiLinkContext)

  return (
    <>

<div className="intro9-section section my-5" data-bg-color="#eff2f6">
  <div className="container-fluid">
    <div className="row align-items-center">
      {/* Intro One Content Start */}
      <div className="col-lg-6 col-md-6" data-aos="fade-up">
        <div className="intro9-content text-center text-md-start">
          <span className="sub-title">Turan Özbahçeci</span>
          <h2 className="title" dangerouslySetInnerHTML={{__html : t.bioTitle}}/>
          <div className="desc">
            {
              bio.slice(0,1).map((item)=>{
                return <div dangerouslySetInnerHTML={{__html : item.biography_az}}/>
              })
            }
            {/* <p>{bio && bio[0].biography_az}</p> */}
          </div>
          <a href="#" className="btn btn-primary btn-hover-secondary">{t.readmore}</a>
        </div>
      </div>
      {/* Intro One Content End */}
      {/* Intro One Course Start */}
      <div className="col-lg-6 col-md-6" data-aos="fade-up">
        {/* Intro Image Start */}
        <div className="intro9-image-wrap">
          <div className="intro9-image">
            <div className="inner-img-one">
              <img className="worldRotate" src="assets/images/intro/intro9/home-business-hero-global-image.png" alt />
            </div>
            <div className="inner-img-two d-flex justify-content-center align-items-center">
              <img src={bioimg} alt="bio img" className='img-fluid w-50' />
            </div>
          </div>
        </div>
        {/* Intro Image End */}
      </div>
      {/* Intro One Course End */}
    </div>
  </div>
</div>




    <div className="biography">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-11 my-5">
                    {/* <p className='text-center fs-5'>{bio[0].biography_az}</p> */}
                </div>
            </div>
        </div>
    </div>
 <div className="success-section section mt-5">
  <div className="container">
    {/* Section Title Start */}
    <div className="section-title text-center" data-aos="fade-up">
      <span className="sub-title secondary-color fs-4">{t.about}</span>
    </div>
    {/* Section Title End */}
    <div className="row">
  {bio.slice(1).map((item, index) => {
    // Eğer index çiftse, metin solda, görsel sağda; tekse metin sağda, görsel solda olacak
    const isEven = index % 2 === 0;
    
    return (
      <div className="col-lg-12" key={index}>
        <div className="mx-timeline">
          <ul className="mx-timeline-list mx-animation-queue">
            <li className="line" />
            <li className="item animate">
              <div className="dots">
                <div className="middle-dot" />
              </div>
              <div className="row">
                {/* Eğer isEven true ise, sol taraf metin sağ taraf resim */}
                {isEven ? (
                  <>
                    <div className="col-md-6 timeline-col left timeline-feature">
                      <div className="inner">
                        <div className="title-wrap">
                          <h5 className="title"> {item.name}</h5>
                        </div>
                        <div className="timeline-image">
                          <img src={item.img} alt="timeline-image-01" className="img-fluid" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 timeline-col right timeline-info">
                      <div className="inner">
                        <div className="timeline-content-wrap">
                          <div className="timeline-content-body">
                            <h4 className="title">#{item.id}</h4>
                            <p className="fs-6" dangerouslySetInnerHTML={{ __html: item.biography_az }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  // Eğer isEven false ise, metin sağda, resim solda
                  <>
                    <div className="col-md-6 timeline-col left timeline-info">
                      <div className="inner">
                        <div className="timeline-content-wrap">
                          <div className="timeline-content-body">
                            <h4 className="title">#{item.id}</h4>
                            <p className="fs-6" dangerouslySetInnerHTML={{ __html: item.biography_az }} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 timeline-col right timeline-feature">
                      <div className="inner">
                        <div className="title-wrap">
                          <h5 className="title">{item.name}</h5>
                        </div>
                        <div className="timeline-image">
                          <img src={item.img} alt="timeline-image-01" className="img-fluid" />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  })}
</div>

  </div>
</div>

    </>
  )
}

export default Biography
